// extracted by mini-css-extract-plugin
export default {"host":"style_host__Eg3mG","projectPanel":"style_projectPanel__U8VS2","content":"style_content__QGCho","approvals":"style_approvals__iqm92"};